import {
  Box,
  DialogContent,
  Tooltip,
  Typography,
  useTheme
} from "@mui/material";
import { useSelector } from "react-redux";
import CustomDialog from "../../../commons/dialog/customDialog";
import PdfView from "../../../commons/file/pdfView";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledFlex } from "../../../styled/flex";
import { StyledFormHeader } from "../../../styled/form";

const FileView = ({ file, open, handleClose, isImage }) => {
  const attachment = useSelector((state) => state.forms.attachment);
  const theme = useTheme();
  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: 2,
          backgroundColor: theme.palette.secondary.dark,
        }}>
        <StyledFlex.Title>
          <Typography sx={StyledFormHeader.text}>{file.nombre}</Typography>
        </StyledFlex.Title>
        <Tooltip title="Cerrar">
          <StyledFormHeader.CloseIcon onClick={handleClose} />
        </Tooltip>
      </Box>
      <DialogContent>
        {attachment.isFetching ? (
          <CircularLoading />
        ) : isImage ? (
          <img
            src={
              file.value
                ? file.base64Header + file.value
                : `data:${file.mimeType};base64,${attachment.data.base64}`
            }
            alt={file.nombre}
          />
        ) : (
          <PdfView
            file={
              file.value
                ? file.base64Header + file.value
                : `data:${file.mimeType};base64,${attachment.data.base64}`
            }
          />
        )}
      </DialogContent>
    </CustomDialog>
  );
};

export default FileView;
